/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnlinkContactAliasRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {UnlinkContactAliasResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const unlinkContactAlias = (request: UnlinkContactAliasRequest, options?: CashRequestOptions) => post<UnlinkContactAliasRequest, UnlinkContactAliasResponse>("/cash-app/aliases/1.0/unlink-contact-alias", request, {...options, rejectOnError: true })